<template>
  <el-dialog
    title="发货信息修改"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
  >
    <el-form size="small" :model="order" ref="order">
      <el-form-item
        label="物流公司"
        :label-width="formLabelWidth"
        prop="param.express_id"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-select v-model="order.param.express_id" placeholder="请选择快递公司">
          <el-option
            :label="item.express_name"
            v-for="(item, index) in expressList"
            :key="index"
            :value="item.express_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="物流单号"
        :label-width="formLabelWidth"
        prop="param.express_no"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-input v-model="order.param.express_no" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="发货状态"
        :label-width="formLabelWidth"
        prop="param.delivery_status"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-select
          size="small"
          v-model="order.param.delivery_status"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in [
              { label: '未发货', value: 10 },
              { label: '已发货', value: 20 },
            ]"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitFunc()" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import OrderApi from "@/api/order.js";
export default {
  props: {
    expressList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      order_id: 0,
      loading: false,
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: false,
      /*表单*/
      order: {},
      detail: {},
    };
  },
  created() {
    this.order_id = this.$route.query.order_id;
  },
  methods: {
    //获取数据
    init(data) {
      this.dialogVisible = true;
      this.order = {};
      if (data) {
        this.detail = data;
        console.log(data);
        this.$nextTick(() => {
          let obj = {
            param: {
              express_id: data.express.express_id,
              express_no: data.express_no,
              delivery_status: data.delivery_status.value,
            },
            order_id: this.order_id,
          };
          this.order = JSON.parse(JSON.stringify(obj));
        });
      }
    },
    /*确认事件*/
    submitFunc() {
      let self = this;
      self.$refs.order.validate((valid) => {
        if (valid) {
          self.loading = true;
          OrderApi.deliveryChange(
            {
              ...this.order,
            },
            true
          )
            .then(() => {
              self.loading = false;

              self.$message({
                message: "修改成功",
                type: "success",
              });
              self.$emit("refresh");
              self.dialogVisible = false;
            })
            .catch((error) => {
              self.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/express.vue